import { render, staticRenderFns } from "./MoleculeSpecsList.vue?vue&type=template&id=a22d63c0&"
import script from "./MoleculeSpecsList.vue?vue&type=script&lang=js&"
export * from "./MoleculeSpecsList.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSpecsList.vue?vue&type=style&index=0&id=a22d63c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomSpecsList: require('/app/components/atoms/common/AtomSpecsList.vue').default})
